import React, {ReactElement} from 'react'
import {FlexContainer, FlexStaticContent} from '../styledComponents/FlexComponents'
import {ContentsAreaComponent} from '../styledComponents/ContentsArea'
import {SubRoutesResident} from '../__NoAutomatedTests/SubRoutesResident'
import {StyledDiv} from '../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, BreakpointValues, Colors, DispWidthSize} from '../styledComponents/Constants'
import FacilitiesRepository from '../components/facilities/FacilitiesRepository'
import AdminAuthRepository from '../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import {EquipmentsRepository} from '../components/equipments/EquipmentsRepository'
import NatResidentHeaderAreaComponent from '../__NoAutomatedTests/components/header/NatResidentHeaderAreaComponent'
import {RoutesResident} from './RoutesResident'
import {GlobalStyleResident} from '../styledComponents/GlobalStyleResident'
import HolidaysRepository from '../components/HolidaysRepository'
import {ReserveFacilityModel} from '../components/reservations/ReserveFacilityModel'
import ReserveFacilityPaymentModel from '../components/reservations/ReserveFacilityPaymentModel'
import ReservationsRepository from '../components/reservations/ReservationsRepository'
import NatCondominiumRepo from '../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatAdminUserRepo from '../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import NatResidentUserRepo from '../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo'
import NatRoomToResidentRepo from '../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumGroupRepo
    from '../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatRidgeRepo from '../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import NatRoomNumberRepo from '../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import ReservePaymentCalculatorFactory
    from '../components/reservations/paymentCalculators/ReservePaymentCalculatorFactory'
import NatTokenRepo from '../__NoAutomatedTests/components/token/repository/NatTokenRepo'
import NatPasswordRepo from '../__NoAutomatedTests/components/password/repository/NatPasswordRepo'
import NatMessageRepo from '../__NoAutomatedTests/components/message/repository/NatMessageRepo'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatLoginRepo from '../__NoAutomatedTests/components/login/repository/NatLoginRepo'
import NatSessionRepo from '../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import NatLoginBeforeMessageRepo
    from '../__NoAutomatedTests/components/loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import NatMenuMasterRepo from '../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import NatLifeNoteRepo from '../__NoAutomatedTests/components/lifeNote/repository/NatLifeNoteRepo'
import NatEventRepo from '../__NoAutomatedTests/components/event/repository/NatEventRepo'
import NatHolidayMasterRepo from '../__NoAutomatedTests/components/holiday/repository/NatHolidayMasterRepo'
import NatEnvSettingRepo from '../__NoAutomatedTests/components/envSetting/repository/NatEnvSettingRepo'
import NatSsoRepo from '../__NoAutomatedTests/components/sso/repository/NatSsoRepo'

import {generateMedia} from 'styled-media-query'
import {SessionStorageHelper} from '../SessionStorageHelper'
import EventEmitterExResident from '../components/shared/pageBaseComponents/EventEmitterExResident'
import NatApartAssocInfoRepo from '../__NoAutomatedTests/components/apartAssocInfo/repository/NatApartAssocInfoRepo'
import CondominiumsRepository from '../components/condominiums/CondominiumsRepository'

import equal from 'fast-deep-equal'
import NatResidentFooterAreaComponent from '../__NoAutomatedTests/components/footer/NatResidentFooterAreaComponent'
import {createTheme, StyledEngineProvider, ThemeProvider} from '@mui/material'
import NatFacilityReserveRepo from '../__NoAutomatedTests/components/facilityReserve/repository/NatFacilityReserveRepo'
import NatBulletinBoardRepo from '../__NoAutomatedTests/components/bulletinBoard/repository/NatBulletinBoardRepo'
import NatCommunicationPlatformRepo
    from '../__NoAutomatedTests/components/communicationPlatform/repository/NatCommunicationPlatformRepo'
import {MeetingRepositoryForResident} from '../components/assocDirector/MeetingRepositoryForResident'
import {NatApplicationRepo} from '../__NoAutomatedTests/components/applications/repository/NatApplicationRepo'
import {NatFileRepo} from '../__NoAutomatedTests/components/files/repository/NatFileRepo'
import {
    NatAssocWorkReportRepo,
} from '../__NoAutomatedTests/components/assocWorkReports/repository/NatAssocWorkReportRepo'
import {Location, matchPath, PathPattern, Route, Routes} from 'react-router-dom'
import {
    NatOwnershipTransfersRepo,
} from '../__NoAutomatedTests/components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import NatCampaignRepo from '../__NoAutomatedTests/components/campaigns/repository/NatCampainRepo'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'
import NatAuthorityRepo from '../__NoAutomatedTests/components/authority/repository/NatAuthorityRepo';
import NatResidentBankAccountInfoRepo
    from '../__NoAutomatedTests/components/accountTransfer/repository/NatResidentBankAccountInfoRepo'
import NatAmountFixRepo from '../__NoAutomatedTests/components/AmountFix/repository/NatAmountFixRepo';
import NatUseFunctionMasterRepo
    from '../__NoAutomatedTests/components/useFunctionMaster/repository/NatUseFunctionMasterRepo';
import NatSutekiNetPlusRepo from '../__NoAutomatedTests/components/mypage/repository/NatSutekiNetPlusRepo'
import NatDisasterRepo from '../__NoAutomatedTests/components/disaster/repository/NatDisasterRepo'
import ResidentGeneralMeetingRepo from '../components/generalMeeting/ResidentGeneralMeetingRepo'

const EVENT_EMITTER_SET_MAX_LISTENERS: number = 1000

interface Props {
    location: Location
    condominiumsRepo: CondominiumsRepository
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    adminAuthRepo: AdminAuthRepository
    equipmentsRepo: EquipmentsRepository
    holidaysRepo: HolidaysRepository
    natTokenRepo: NatTokenRepo
    natCondominiumRepo: NatCondominiumRepo
    natAdminUserRepo: NatAdminUserRepo
    natResidentUserRepo: NatResidentUserRepo
    natRoomToResidentRepo: NatRoomToResidentRepo
    natCondominiumGroupRepo: NatCondominiumGroupRepo
    natRidgeRepo: NatRidgeRepo
    natRoomNumberRepo: NatRoomNumberRepo
    natPasswordRepo: NatPasswordRepo
    natMessageRepo: NatMessageRepo
    natCurrentDateTimeRepo: NatCurrentDateTimeRepo
    natLoginRepo: NatLoginRepo
    natSessionRepo: NatSessionRepo
    natLoginBeforeMessageRepo: NatLoginBeforeMessageRepo
    natmenuMasterRepo: NatMenuMasterRepo
    natLifeNoteRepo: NatLifeNoteRepo
    natEventRepo: NatEventRepo
    natHolidayMasterRepo: NatHolidayMasterRepo
    natApartAssocInfoRepo: NatApartAssocInfoRepo
    natFacilityReserveRepo: NatFacilityReserveRepo
    natBulletinBoardRepo: NatBulletinBoardRepo
    natEnvSettingRepo: NatEnvSettingRepo
    natSsoRepo: NatSsoRepo
    natCommunicationPlatformRepo: NatCommunicationPlatformRepo
    meetingRepoForResident: MeetingRepositoryForResident
    applicationRepo: NatApplicationRepo
    fileRepo: NatFileRepo
    assocWorkReportRepo: NatAssocWorkReportRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    campaignRepo: NatCampaignRepo
    natAuthorityRepo: NatAuthorityRepo
    bankAccountInfoRepo: NatResidentBankAccountInfoRepo
    billingAmountFixInfoRepo: NatAmountFixRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    sutekiNetPlusRepo: NatSutekiNetPlusRepo
    disasterRepo: NatDisasterRepo
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
}

interface State {
    loginedFlg: boolean
}

const theme = createTheme({
    typography: {
        fontFamily: '"Noto Sans JP","游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN",\
                     "Hiragino Kaku Gothic Pro",メイリオ,Meiryo,sans-serif',
    },
    breakpoints: {
        values: BreakpointValues,
    },
})

export default class AppResident extends React.Component<Props, State> {
    private reservationModel: ReserveFacilityModel
    private eventEmitter: EventEmitterExResident
    private paymentModel: ReserveFacilityPaymentModel
    private paymentCalculatorFactory: ReservePaymentCalculatorFactory

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            loginedFlg: (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null),
        }

        this.paymentCalculatorFactory = new ReservePaymentCalculatorFactory()
        this.paymentModel = new ReserveFacilityPaymentModel(this.paymentCalculatorFactory)
        this.reservationModel = new ReserveFacilityModel(this.paymentModel)
        this.eventEmitter = new EventEmitterExResident()
        this.eventEmitter.setMaxListeners(EVENT_EMITTER_SET_MAX_LISTENERS)
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        if (!equal(prevState.loginedFlg, (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null))) {
            this.setState(
                {loginedFlg: (SessionStorageHelper.getStringItemOrNull('AUTHORITIES') !== null)})
        }
    }

    render(): ReactElement {
        const loginedFlg = !isLogoffPage(this.props.location) && this.state.loginedFlg

        return <>
            <GlobalStyleResident/>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>

                    <ResidentRootFlexContainer>
                        <ResidentHeaderFlexContainer>
                            <Routes>
                                <Route
                                    path="/resident/mypage"
                                    element={<RouterPropsInjector>{(props) =>
                                        <NatResidentHeaderAreaComponent
                                            navigate={props.navigate}
                                            location={props.location}
                                            menuMasterRepo={this.props.natmenuMasterRepo}
                                            residentUserRepo={this.props.natResidentUserRepo}
                                            loginRepo={this.props.natLoginRepo}
                                            assocWorkReportRepo={this.props.assocWorkReportRepo}
                                            disasterRepo={this.props.disasterRepo}
                                            loginedFlg={loginedFlg}
                                            mypageFlg={true}
                                            eventEmitter={this.eventEmitter}
                                            sessionRepo={this.props.natSessionRepo}
                                            residentGeneralMeetingRepo={this.props.residentGeneralMeetingRepo}
                                        />
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/resident/hasekoIdRegistration"
                                    element={<RouterPropsInjector>{(props) =>
                                        <NatResidentHeaderAreaComponent
                                            navigate={props.navigate}
                                            location={props.location}
                                            menuMasterRepo={this.props.natmenuMasterRepo}
                                            residentUserRepo={this.props.natResidentUserRepo}
                                            loginRepo={this.props.natLoginRepo}
                                            assocWorkReportRepo={this.props.assocWorkReportRepo}
                                            disasterRepo={this.props.disasterRepo}
                                            loginedFlg={false}
                                            isNoTransitionFlg={true}
                                            eventEmitter={this.eventEmitter}
                                            sessionRepo={this.props.natSessionRepo}
                                            residentGeneralMeetingRepo={this.props.residentGeneralMeetingRepo}
                                        />
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/resident/hasekoIdLinkComplete"
                                    element={<RouterPropsInjector>{(props) =>
                                        <NatResidentHeaderAreaComponent
                                            navigate={props.navigate}
                                            location={props.location}
                                            menuMasterRepo={this.props.natmenuMasterRepo}
                                            residentUserRepo={this.props.natResidentUserRepo}
                                            loginRepo={this.props.natLoginRepo}
                                            assocWorkReportRepo={this.props.assocWorkReportRepo}
                                            disasterRepo={this.props.disasterRepo}
                                            loginedFlg={false}
                                            isNoTransitionFlg={true}
                                            eventEmitter={this.eventEmitter}
                                            sessionRepo={this.props.natSessionRepo}
                                            residentGeneralMeetingRepo={this.props.residentGeneralMeetingRepo}
                                        />
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/*"
                                    element={<RouterPropsInjector>{(props) =>
                                        <NatResidentHeaderAreaComponent
                                            navigate={props.navigate}
                                            location={props.location}
                                            menuMasterRepo={this.props.natmenuMasterRepo}
                                            residentUserRepo={this.props.natResidentUserRepo}
                                            loginRepo={this.props.natLoginRepo}
                                            assocWorkReportRepo={this.props.assocWorkReportRepo}
                                            disasterRepo={this.props.disasterRepo}
                                            loginedFlg={loginedFlg}
                                            eventEmitter={this.eventEmitter}
                                            sessionRepo={this.props.natSessionRepo}
                                            residentGeneralMeetingRepo={this.props.residentGeneralMeetingRepo}
                                        />
                                    }</RouterPropsInjector>}
                                />
                            </Routes>
                        </ResidentHeaderFlexContainer>

                        <ResidentContentsAreaContainer>
                            <ResidentContentsAreaComponent>
                                <Routes>
                                    {RoutesResident({
                                        eventEmitter: this.eventEmitter,
                                        condominiumsRepo: this.props.condominiumsRepo,
                                        facilitiesRepo: this.props.facilitiesRepo,
                                        reservationsRepo: this.props.reservationsRepo,
                                        holidaysRepo: this.props.holidaysRepo,
                                        reservationModel: this.reservationModel,
                                        ridgeRepo: this.props.natRidgeRepo,
                                        roomNumberRepo: this.props.natRoomNumberRepo,
                                        tokenRepo: this.props.natTokenRepo,
                                        residentUserRepo: this.props.natResidentUserRepo,
                                        currentDateTimeRepo: this.props.natCurrentDateTimeRepo,
                                        meetingRepoForResident: this.props.meetingRepoForResident,
                                        residentGeneralMeetingRepo: this.props.residentGeneralMeetingRepo,
                                        useFunctionMasterRepo: this.props.useFunctionMasterRepo,
                                    })}
                                    {SubRoutesResident({
                                        eventEmitter: this.eventEmitter,
                                        tokenRepo: this.props.natTokenRepo,
                                        condominiumRepo: this.props.natCondominiumRepo,
                                        condominiumsRepo: this.props.condominiumsRepo,
                                        adminUserRepo: this.props.natAdminUserRepo,
                                        residentUserRepo: this.props.natResidentUserRepo,
                                        roomToResidentRepo: this.props.natRoomToResidentRepo,
                                        condominiumGroupRepo: this.props.natCondominiumGroupRepo,
                                        ridgeRepo: this.props.natRidgeRepo,
                                        passwordRepo: this.props.natPasswordRepo,
                                        messageRepo: this.props.natMessageRepo,
                                        currentDateTimeRepo: this.props.natCurrentDateTimeRepo,
                                        residentLoginRepo: this.props.natLoginRepo,
                                        sessionRepo: this.props.natSessionRepo,
                                        loginBeforeMessageRepo: this.props.natLoginBeforeMessageRepo,
                                        menuMasterRepo: this.props.natmenuMasterRepo,
                                        lifeNoteRepo: this.props.natLifeNoteRepo,
                                        eventRepo: this.props.natEventRepo,
                                        holidayMasterRepo: this.props.natHolidayMasterRepo,
                                        apartAssocInfoRepo: this.props.natApartAssocInfoRepo,
                                        reservationsRepo: this.props.reservationsRepo,
                                        facilityReserveRepo: this.props.natFacilityReserveRepo,
                                        bulletinBoardRepo: this.props.natBulletinBoardRepo,
                                        envSettingRepo: this.props.natEnvSettingRepo,
                                        ssoRepo: this.props.natSsoRepo,
                                        communicationPlatformRepo: this.props.natCommunicationPlatformRepo,
                                        meetingRepo: this.props.meetingRepoForResident,
                                        applicationRepo: this.props.applicationRepo,
                                        holidaysRepo: this.props.holidaysRepo,
                                        fileRepo: this.props.fileRepo,
                                        assocWorkReportRepo: this.props.assocWorkReportRepo,
                                        ownershipTransfersRepo: this.props.ownershipTransfersRepo,
                                        campaignRepo: this.props.campaignRepo,
                                        adminAuthRepo: this.props.adminAuthRepo,
                                        authorityRepo: this.props.natAuthorityRepo,
                                        bankAccountInfoRepo: this.props.bankAccountInfoRepo,
                                        amountFixRepo: this.props.billingAmountFixInfoRepo,
                                        useFunctionMasterRepo: this.props.useFunctionMasterRepo,
                                        sutekiNetPlusRepo: this.props.sutekiNetPlusRepo,
                                        disasterRepo: this.props.disasterRepo,
                                        residentGeneralMeetingRepo: this.props.residentGeneralMeetingRepo,
                                    })}
                                </Routes>
                            </ResidentContentsAreaComponent>
                        </ResidentContentsAreaContainer>

                        <Routes>
                            <Route
                                path="/resident/hasekoIdRegistration"
                                element={<RouterPropsInjector>{(props) =>
                                    <footer>
                                        <ResidentFooterFlexStaticContent>
                                            <NatResidentFooterAreaComponent
                                                navigate={props.navigate}
                                                loginedFlg={false}
                                                isNoTransitionFlg={true}
                                            />
                                        </ResidentFooterFlexStaticContent>
                                    </footer>
                                }</RouterPropsInjector>}
                            />
                            <Route
                                path="/resident/hasekoIdLinkComplete"
                                element={<RouterPropsInjector>{(props) =>
                                    <footer>
                                        <ResidentFooterFlexStaticContent>
                                            <NatResidentFooterAreaComponent
                                                navigate={props.navigate}
                                                loginedFlg={false}
                                                isNoTransitionFlg={true}
                                            />
                                        </ResidentFooterFlexStaticContent>
                                    </footer>
                                }</RouterPropsInjector>}
                            />
                            <Route
                                path="/*"
                                element={<RouterPropsInjector>{(props) =>
                                    <footer>
                                        <ResidentFooterFlexStaticContent>
                                            <NatResidentFooterAreaComponent
                                                navigate={props.navigate}
                                                loginedFlg={loginedFlg}
                                            />
                                        </ResidentFooterFlexStaticContent>
                                    </footer>
                                }</RouterPropsInjector>}
                            />
                        </Routes>
                    </ResidentRootFlexContainer>
                </ThemeProvider>
            </StyledEngineProvider>
        </>
    }
}

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const ResidentRootFlexContainer = styled(FlexContainer)`
  flex-direction: column;
  height: 100%;
  background: ${Colors.Background};
`

const ResidentHeaderFlexContainer: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const ResidentFooterFlexStaticContent = styled(FlexStaticContent)`
  background-color: ${Colors.Primary};
`

const ResidentContentsAreaContainer: StyledDiv = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  background-color: ${Colors.Background};

  ${breakPoint.lessThan('sp')`
      display: contents;
  `}
`

const ResidentContentsAreaComponent = styled(ContentsAreaComponent)`
  width: 100%;
  max-width: ${DispWidthSize.MaxWidth};
  margin-left: auto;
  margin-right: auto;
  box-shadow: 6px 0 5px -5px ${Colors.Shadow}, -6px 0 5px -5px ${Colors.Shadow};

  ${breakPoint.lessThan('sp')`
    min-height: 0;
    box-shadow: none;
  `}
`

const LOGOFF_PAGES: PathPattern[] = [
    {path: '/resident/login', end: true},
    {path: '/resident/condominiumSelect', end: true},
    {path: '/resident/firstLoginPolicyAgree', end: true},
    {path: '/resident/firstLoginHasekoIdDescription', end: true},
    {path: '/resident/firstLoginAuthenticationKeyInput', end: true},
    {path: '/resident/firstLoginHasekoIdConfirm', end: true},
    {path: '/resident/firstLoginMailAddressRegister', end: true},
    {path: '/resident/firstLoginMailSendComplete', end: true},
    {path: '/resident/firstLoginUserInfoInput', end: true},
    {path: '/resident/firstLoginUserInfoConfirm', end: true},
    {path: '/resident/hasekoIdRegistration', end: true},
    {path: '/resident/firstLoginUserInfoRegisterComplete', end: true},
    {path: '/resident/firstLoginHasekoIdPasswordConfirm', end: true},
    {path: '/resident/firstLoginSutekiPasswordConfirm', end: true},
    {path: '/resident/hasekoIdLinkComplete', end: true},
    {path: '/resident/passwordResetMailAddressInput', end: true},
    {path: '/resident/passwordResetMailAddressComplete', end: true},
    {path: '/resident/passwordResetInput', end: true},
    {path: '/resident/passwordResetComplete', end: true},
    {path: '/resident/changeMailAddressComplete', end: true},
    {path: '/resident/contactus', end: true},
    {path: '/resident/externalTransmission', end: true},
    {path: '/resident/error', end: true},
    {path: '/resident/contents/policyTerms', end: true},
    {path: '/resident/contents/maintenance', end: true},
    {path: '/resident/external/reception', end: true},
    {path: '/resident/ssoLoginRedirect', end: true},
    {path: '/resident/public/account-transfer/result/:status', end: true},
]

function isLogoffPage(location: Location): boolean {
    return LOGOFF_PAGES.some(logoffPage => matchPath(logoffPage, location.pathname))
}
